export const isLoggedIn = () => {
    try {
        const token = document.cookie
            .split("; ")
            .find((row) => row.startsWith("token="))
            ?.split("=")[1];
        
        // Check if URL contains checkoutUrl parameter
        return !!token;
    } catch {
        return false;
    }
};
